import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSucoMobile = (e: React.MouseEvent) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === '/suco') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/suco');
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { to: '/', label: 'Início' },
    { to: '/vinhos', label: 'Vinhos' },
    { to: '/vinagre', label: 'Vinagre' },
    { to: '/suco', label: 'Suco de Uva' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#FCF1D7]/97 backdrop-blur-md border-b border-[#878450]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/77ede6cfebdeef4356c517ccc70ad5e9/177ec42a90177c346f55db4cbfb1cc8d.png"
            alt="Logo Vinícola Suave"
            className="h-32 w-auto object-contain"
          />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-1">
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer font-body ${
                isActive(link.to)
                  ? scrolled
                    ? 'bg-[#710005] text-[#FCF1D7]'
                    : 'bg-white/20 text-white'
                  : scrolled
                  ? 'text-[#2C0000] hover:bg-[#878450]/15 hover:text-[#710005]'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <a
          href="https://wa.me/5500000000000"
          target="_blank"
          rel="nofollow noreferrer"
          className={`hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
            scrolled
              ? 'bg-[#710005] text-[#FCF1D7] hover:bg-[#2C0000]'
              : 'bg-[#FCF1D7] text-[#710005] hover:bg-white'
          }`}
          style={{ fontFamily: "'Sora', sans-serif" }}
        >
          <i className="ri-whatsapp-line text-base"></i>
          Pedir Agora
        </a>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden p-2 rounded-lg cursor-pointer ${scrolled ? 'text-[#2C0000]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#FCF1D7] border-t border-[#878450]/20 px-4 py-4 flex flex-col gap-2">
          {links.map((link) => {
            const isSuco = link.to === '/suco';
            return isSuco ? (
              <a
                key={link.to}
                href="/suco"
                onClick={handleSucoMobile}
                className={`px-4 py-3 text-sm font-medium rounded-lg cursor-pointer ${
                  isActive(link.to)
                    ? 'bg-[#710005] text-[#FCF1D7]'
                    : 'text-[#2C0000] hover:bg-[#878450]/15'
                }`}
                style={{ fontFamily: "'Sora', sans-serif" }}
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className={`px-4 py-3 text-sm font-medium rounded-lg cursor-pointer ${
                  isActive(link.to)
                    ? 'bg-[#710005] text-[#FCF1D7]'
                    : 'text-[#2C0000] hover:bg-[#878450]/15'
                }`}
                style={{ fontFamily: "'Sora', sans-serif" }}
              >
                {link.label}
              </Link>
            );
          })}
          <a
            href="https://wa.me/5500000000000"
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-2 flex items-center justify-center gap-2 px-4 py-3 bg-[#710005] text-[#FCF1D7] rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            <i className="ri-whatsapp-line"></i>
            Pedir Agora pelo WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
